import React, { useState, useEffect } from 'react'
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  InputGroup
} from 'react-bootstrap'
import { Card } from '../../components/Card/Card'
import ReactTooltip from 'react-tooltip'
import ReactQuill from 'react-quill'
import Loading from '../../components/Loading/Loading'
import { Link } from 'react-router-dom'
import { translate } from 'react-i18next'
import { firebaseDb as db } from '../../firebase'
import Button from '../../components/CustomButton/CustomButton'
import UploadSingleImage from '../../components/FormInputs/UploadSingleImage'
import moment from 'moment-timezone'
import i18next from 'i18next'
import { map } from 'lodash'
import { ChromePicker } from 'react-color'
import { Radio, Modal, Switch } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import TimezoneSelect from 'react-timezone-select'

// Translation model
import { read } from '../../helpers/translationModel/read'
import { write } from '../../helpers/translationModel/write'

// Redux
import { useSelector, useDispatch } from 'react-redux'

// Data
import languagesData from '../../data/languages.json'

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faInstagram, faYoutube, faXing, faLinkedinIn, faVimeoV } from '@fortawesome/free-brands-svg-icons';
import { faCircle, faSquare } from '@fortawesome/free-solid-svg-icons';
import FileSelector from '../FileStorage/Parts/FileSelector'

const SocialMediaIcon = (props) => {
  return (
    <FontAwesomeIcon
      icon={props.icon}
      size={props.size}
      mask={props.isRound ? faCircle : faSquare}
      transform="shrink-7"
      color={props.color} />
  )
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

const timerFields = [
  "homeTab",
  "rankingTab",
  "tableTitle",
  "tablePosition",
  "tableUsername",
  "tableClicks",
  "tablePairs",
  "tableTime",
  "tablePoints",
  "modalStep1Title",
  "modalStep2Title",
  "modalStep3Title",
  "restartGameButtonText",
  "saveButtonText",
  "cancelButtonText",
  "noRankingDataAvailable"
]

const timerRichTextFields = [
  "modalStep1Description",
  "modalStep2Description",
  "modalStep3Description"
]

const hsCounterTextFields = [
  "winningTitle",
  "losingTitle",
  "gameOverTitle",
  "winningButtonText",
  "losingButtonText",
  "gameOverButtonText",
]

const hsCounterTextRichTextFields = [
  "winningText",
  "losingText",
  "gameOverText",
]

const CalSetttings = props => {
  const {
    activeCompany,
    activeCalendar,
    calendarLang,
    calendarLangPrimary
  } = useSelector(state => state)
  const [currentLanguge, setCurrentLanguage] = useState(i18next.language)
  const [, setCalendarLanguages] = useState()

  const [loading, setLoading] = useState(true)
  const [deleteLanguageModal, setDeleteLanguageModal] = useState(false);
  const [confirmDeleteLanguage, setConfirmDeleteLanguage] = useState(false);


  // Input state
  const [type, setType] = useState()
  const [, setCalendarName] = useState()
  const [allowAuth, setAllowAuth] = useState()
  const [, setCalendarPassword] = useState()
  const [allowPreviousDays, setAllowPreviousDays] = useState()
  const [beforeLaunchModal, setBeforeLaunchModal] = useState('')
  const [afterLaunchModal, setAfterLaunchModal] = useState('')
  const [socialHeadline, setSocialHeadline] = useState('')
  const [, setSocial] = useState()
  const [social2, setSocial2] = useState()
  const [social3, setSocial3] = useState()
  const [timezone, setTimezone] = useState("Europe/Berlin")
  const [, setHubspotPortalId] = useState()
  const [, setGaTrackingId] = useState()
  const [, setGaTagManager] = useState()
  const [, setShutdownDate] = useState()
  const [, setStartDate] = useState()
  const [allowModalsAfterShutdown, setAllowModalsAfterShutdown] = useState()
  const [disableFormSubmission, setDisableFormSubmission] = useState({
    disabled: false,
    date: "",
    text: "Submission closed by admin"
  });
  const [, setCalendarUrl] = useState()
  const [modalBeforeDesign, setModalBeforeDesign] = useState()
  const [modules, setModules] = useState()
  const [, setOgTitle] = useState()
  const [, setOgType] = useState()
  const [, setOgUrl] = useState()
  const [, setOgDescription] = useState()
  const [ogImage, setOgImage] = useState()
  const [shareButton, setShareButton] = useState()
  const [languages, setLanguages] = useState({})
  const [languagePrimary, setLanguagePrimary] = useState()
  const [addLanguage, setAddLanguage] = useState()
  const [displayLanguageSelector, setDisplayLanguageSelector] = useState(true)
  const [enableInactiveColor, setEnableInactiveColor] = useState(false)
  const [useStockIcons, setUseStockIcons] = useState(false)
  const [inactiveColor, setInactiveColor] = useState()
  const [socialMediaIcons, setSocialMediaIcons] = useState({ color: '#606060', size: '2x', isRound: true })
  const [popupColor, setPopupColor] = useState('#D60003')
  const [showTimerTranslations, setShowTimerTranslations] = useState(false)
  const [enableCaptcha, setEnableCaptcha] = useState(false)
  const [hasTouchedReplaceEmptyTranslations, setHasTouchedReplaceEmptyTranslations] = useState(false)
  const [replaceEmptyTranslations, setReplaceEmptyTranslations] = useState(false)
  const [timerTextTranslations, setTimerTextTranslations] = useState(timerFields.reduce((acc, field) => {
    acc[field] = ''
    return acc
  }, {}))
  const [timerRichTextTranslations, setTimerRichTextTranslations] = useState(timerRichTextFields.reduce((acc, field) => {
    acc[field] = ''
    return acc
  }, {}))
  const [enableCounterTranslations, setEnableCounterTranslations] = useState(false)
  const [hsCounterTextTranslations, setHsCounterTextTranslations] = useState(hsCounterTextFields.reduce((acc, field) => {
    acc[field] = ''
    return acc
  }, {}))
  const [hsCounterTextRichTextTranslations, setHsCounterTextRichTextTranslations] = useState(hsCounterTextRichTextFields.reduce((acc, field) => {
    acc[field] = ''
    return acc
  }, {}))
  const dispatch = useDispatch()
  console.log('enableCaptcha', enableCaptcha)

  useEffect(() => {
    activeCompany && activeCalendar && loadFromDb()
  }, [activeCompany, activeCalendar, calendarLang])

  useEffect(() => {
    if(!showTimerTranslations) return;
    if(typeof timerTextTranslations === 'object' && Object.values(timerTextTranslations).entries(c => c !== '' && !!c)) {
      timerFields.forEach(field => {
        document.getElementById(field).value = timerTextTranslations[field] || ''
      })
    }
  }, [showTimerTranslations])

  useEffect(() => {
    if(!enableCounterTranslations) return;
    if(typeof hsCounterTextTranslations === 'object' && Object.values(hsCounterTextTranslations).entries(c => c !== '' && !!c)) {
      hsCounterTextFields.forEach(field => {
        document.getElementById(field).value = hsCounterTextTranslations[field] || ''
      })
    }
  }, [enableCounterTranslations])

  const loadFromDb = () => {
    activeCompany &&
      activeCalendar &&
      db
        .doc(
          'companies/' +
          activeCompany +
          '/calendars/' +
          activeCalendar +
          '/settings/grid'
        )
        .get()
        .then(async querySnapshot => {
          let data = querySnapshot.data()

          // Replace data with translations
          data = await read(
            activeCompany,
            activeCalendar,
            calendarLangPrimary,
            calendarLang,
            'settings/grid',
            data
          )

          const modules = {
            toolbar: [
              [{ size: ['small', false, 'large', 'huge'] }],
              [{ header: [1, 2, false] }],
              [{ align: [] }],
              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
              [
                { list: 'ordered' },
                { list: 'bullet' },
                { indent: '-1' },
                { indent: '+1' }
              ],
              ['link', 'image'],
              [{ color: Object.values(data.colors) }, { color: [] }],
              ['clean']
            ]
          }

          let shutdownDate,
            startDate,
            allowPreviousDays,
            allowModalsAfterShutdown
          const timezone = data.timezone || "Europe/Berlin"
          if (data.startDate && data.startDate.seconds > 0) {
            startDate = moment(data.startDate.toDate()).clone().tz(timezone).format('YYYY-MM-DD')
          }
          if (data.shutdownDate && data.shutdownDate.seconds > 0) {
            shutdownDate = moment(data.shutdownDate.toDate()).clone().tz(timezone).format('YYYY-MM-DD')
          }
          if (data.allowPreviousDays) {
            allowPreviousDays = data.allowPreviousDays.toString()
          }
          if (data.allowModalsAfterShutdown) {
            allowModalsAfterShutdown = data.allowModalsAfterShutdown.toString()
          }

          const social2Update = data.social2
            ? {
              headline: data.social2.headline,
              facebook: data.social2.facebook,
              instagram: data.social2.instagram,
              linkedin: data.social2.linkedin,
              twitter: data.social2.twitter,
              youtube: data.social2.youtube,
              xing: data.social2.xing
            }
            : null

          const social3Update = data.social3
            ? {
              headline: data.social3.headline,
              facebook: data.social3.facebook,
              instagram: data.social3.instagram,
              linkedin: data.social3.linkedin,
              youtube: data.social3.youtube,
              xing: data.social3.xing
            }
            : null

          setType(data.type)
          setCalendarName(data.calendarName)
          setAllowAuth((data.auth && data.auth.enable) || 'false')
          setCalendarPassword(data.calendarPassword)
          setAllowPreviousDays(allowPreviousDays)
          setBeforeLaunchModal(data.beforeLaunchModal || '')
          setAfterLaunchModal(data.afterLaunchModal || '')
          setSocialHeadline(data.social.headline || '')
          setSocial({
            headline: data.social.headline,
            facebook: data.social.facebook,
            instagram: data.social.instagram,
            linkedin: data.social.linkedin,
            twitter: data.social.twitter,
            youtube: data.social.youtube,
            xing: data.social.xing,
            vimeo: data.social.vimeo,
          })
          setSocial2(social2Update)
          setSocial3(social3Update)
          setTimezone(timezone)
          setHubspotPortalId(data.hubspotPortalId)
          setGaTrackingId(data.gaTrackingId)
          setGaTagManager(data.gaTagManager)
          setShutdownDate(shutdownDate)
          setStartDate(startDate)
          setAllowModalsAfterShutdown(allowModalsAfterShutdown)
          setCalendarUrl(data.social.calendarUrl)
          setModalBeforeDesign(data.modalBeforeDesign)
          setLoading(false)
          setModules(modules)
          setOgTitle(data.ogTitle)
          setOgType(data.ogType)
          setOgUrl(data.ogUrl)
          setOgDescription(data.ogDescription)
          setOgImage(data.ogImage)
          setShareButton(data.shareButton)
          setLanguages(data.languages || {})
          setLanguagePrimary(data.languagePrimary)
          setDisplayLanguageSelector(data.displayLanguageSelector === undefined ?
            true : data.displayLanguageSelector)
          setEnableInactiveColor(data.enableInactiveColor || false)
          setUseStockIcons(data.useStockIcons || false)
          setShowTimerTranslations(data.showTimerTranslations || false)
          setEnableCaptcha(!!data.enableCaptcha || false)
          setReplaceEmptyTranslations(data.replaceEmptyTranslations || false)
          setHasTouchedReplaceEmptyTranslations(data.hasTouchedReplaceEmptyTranslations || false)
          setEnableCounterTranslations(data.enableCounterTranslations || false)
          if (data.inactiveColor) {
            setInactiveColor(data.inactiveColor)
          }
          if (data.socialMediaIcons) {
            setSocialMediaIcons(data.socialMediaIcons)
          }
          if (data.popupColor) {
            setPopupColor(data.popupColor)
          }
          if (data.disableFormSubmission) {
            setDisableFormSubmission({
              text: data.disableFormSubmission.text || "",
              disabled: data.disableFormSubmission.disabled,
              date: data.disableFormSubmission.date
            })
            document.getElementById('submissionCloseDate').value = data.disableFormSubmission.date
          }

          document.getElementById('calendarName').value = data.calendarName
          // Auth
          if (data.auth) {
            document.getElementById('authPassword').value =
              data.auth.password || ''
            document.getElementById('authUrlPassword').value =
              data.auth.urlPassword || ''
            document.getElementById('authPlaceholder').value =
              data.auth.placeholder || ''
            document.getElementById('authButtonLogin').value =
              data.auth.buttonLogin || ''
            document.getElementById('authPleaseLogin').value =
              data.auth.pleaseLogin || ''
            document.getElementById('authCreateAccount').value =
              data.auth.createAccount || ''
            document.getElementById('authCreateAccountUrl').value =
              data.auth.createAccountUrl || ''
            document.getElementById('authWrongPassword').value =
              data.auth.wrongPassword || ''
          }

          document.getElementById('calendarUrl').value = data.calendarUrl || ''

          document.getElementById('facebook').value = data.social.facebook || ''
          document.getElementById('instagram').value =
            data.social.instagram || ''
          document.getElementById('linkedin').value = data.social.linkedin || ''
          document.getElementById('twitter').value = data.social.twitter || ''
          document.getElementById('youtube').value = data.social.youtube || ''
          document.getElementById('xing').value = data.social.xing || ''
          document.getElementById('vimeo').value = data.social.vimeo || ''

          if (data.social2) {
            document.getElementById('socialHeadline2').value =
              data.social2.headline
            document.getElementById('facebook2').value =
              data.social2.facebook || ''
            document.getElementById('instagram2').value =
              data.social2.instagram || ''
            document.getElementById('linkedin2').value =
              data.social2.linkedin || ''
            document.getElementById('twitter2').value =
              data.social2.twitter || ''
            document.getElementById('youtube2').value =
              data.social2.youtube || ''
            document.getElementById('xing2').value = data.social2.xing || ''
          }

          if (data.social3) {
            document.getElementById('socialHeadline3').value =
              data.social3.headline
            document.getElementById('facebook3').value =
              data.social3.facebook || ''
            document.getElementById('instagram3').value =
              data.social3.instagram || ''
            document.getElementById('linkedin3').value =
              data.social3.linkedin || ''
            document.getElementById('twitter3').value =
              data.social3.twitter || ''
            document.getElementById('youtube3').value =
              data.social3.youtube || ''
            document.getElementById('xing3').value = data.social3.xing || ''
          }

          document.getElementById('ogTitle').value = data.ogTitle || ''
          document.getElementById('ogType').value = data.ogType || ''
          document.getElementById('ogUrl').value = data.ogUrl || ''
          document.getElementById('ogDescription').value =
            data.ogDescription || ''
          data.ogImage && setOgImage(data.ogImage)
          document.getElementById('beforeLaunchModal').value =
            data.beforeLaunchModal
          document.getElementById('afterLaunchModal').value =
            data.afterLaunchModal

          document.getElementById('hubspotPortalId').value =
            data.hubspotPortalId
          document.getElementById('gaTrackingId').value = data.gaTrackingId
          document.getElementById('gaTagManager').value = data.gaTagManager
          document.getElementById('startDate').value = startDate
          document.getElementById('shutdownDate').value = shutdownDate

          document.getElementById('errorField').value = data.errorField || ''

          if (typeof data.timerRichTextTranslations === 'object' && !Object.values(data.timerRichTextTranslations).every(c => c === '' || !c)) {
            setTimerRichTextTranslations(data.timerRichTextTranslations)
          }

          if (typeof data.timerTextTranslations === 'object' && !Object.values(data.timerTextTranslations).every(c => c === '' || !c)) {
            timerFields.forEach(field => {
              if(document.getElementById(field)) {
                document.getElementById(field).value = data.timerTextTranslations[field] || ''
              }
            })
            setTimerTextTranslations(data.timerTextTranslations)
          }

          if (typeof data.hsCounterTextTranslations === 'object' && !Object.values(data.hsCounterTextTranslations).every(c => c === '' || !c)) {
            hsCounterTextFields.forEach(field => {
              if(document.getElementById(field)) {
                document.getElementById(field).value = data.hsCounterTextTranslations[field] || ''
              }
            })
            setHsCounterTextTranslations(data.hsCounterTextTranslations)
          }

          if (typeof data.hsCounterTextRichTextTranslations === 'object' && !Object.values(data.hsCounterTextRichTextTranslations).every(c => c === '' || !c)) {
            setHsCounterTextRichTextTranslations(hsCounterTextRichTextFields.reduce((acc, field) => {
              acc[field] = data.hsCounterTextRichTextTranslations[field] || ''
              return acc
            }, {}))
          }
        })
        .catch(error => {
          notificationOpen('error', error)
        })
    db
      .doc(
        'companies/' +
        activeCompany +
        '/calendars/' +
        activeCalendar
      )
      .get()
      .then(querySnapshot => document.getElementById('internalCalendarName').value = querySnapshot.data().name)
  }

  const handleChangeShareButton = event => {
    setShareButton(event.target.value)
  }

  const handleChangeShowTimerTranslations = event => {
    setShowTimerTranslations(event.target.checked)
    if (!hasTouchedReplaceEmptyTranslations) {
      setHasTouchedReplaceEmptyTranslations(true)
      setReplaceEmptyTranslations(true)
    }
  }

  const handleChangeEnableCaptcha = event => {
    setEnableCaptcha(event.target.checked)
  }

  const handleChangeEnableCounterTranslations = event => {
    setEnableCounterTranslations(event.target.checked)
  }

  const handleChangeTimerRichTextTranslations = (field, value) => {
    setTimerRichTextTranslations((prev) => ({ ...prev, [field]: value }))
  }

  const handleChangeHsCounterTextRichTextTranslations = (field, value) => {
    setHsCounterTextRichTextTranslations((prev) => ({ ...prev, [field]: value }))
  }

  const handleSubmit = event => {
    event.preventDefault()
    const data = new FormData(event.target)
    const beforeLaunchModal = document.querySelector(
      '#beforeLaunchModal .ql-editor'
    ).innerHTML
    const afterLaunchModal = document.querySelector(
      '#afterLaunchModal .ql-editor'
    ).innerHTML
    const socialHeadline = document.querySelector(
      '#socialHeadline .ql-editor'
    ).innerHTML
    const submissionCloseMessage = document.querySelector(
      '#submissionCloseMessage .ql-editor'
    ).innerHTML

    if (data) {
      let shutdownDate = data.get('shutdownDate') + ' 00:00:00'
      let startDate = data.get('startDate') + ' 00:00:00'
      let submissionCloseDate = data.get('submissionCloseDate') || document.getElementById('submissionCloseDate').value || "";
      const timezoneString = timezone.value ? timezone.value : timezone
      shutdownDate = moment.tz(shutdownDate, timezoneString).toDate()
      startDate = moment.tz(startDate, timezoneString).toDate()
      submissionCloseDate = submissionCloseDate ? submissionCloseDate : ""

      // TODO: remove social duplicates
      const social2Update = social2
        ? {
          headline: data.get('socialHeadline2'),
          facebook: data.get('facebook2'),
          instagram: data.get('instagram2'),
          linkedin: data.get('linkedin2'),
          twitter: data.get('twitter2'),
          youtube: data.get('youtube2'),
          xing: data.get('xing2')
        }
        : null

      const social3Update = social3
        ? {
          headline: data.get('socialHeadline3'),
          facebook: data.get('facebook3'),
          instagram: data.get('instagram3'),
          linkedin: data.get('linkedin3'),
          twitter: data.get('twitter3'),
          youtube: data.get('youtube3'),
          xing: data.get('xing3')
        }
        : null

      const udpateContent = {
        calendarName: data.get('calendarName'),
        internalCalendarName: data.get('internalCalendarName'),
        auth: {
          enable: allowAuth,
          password: data.get('authPassword'),
          urlPassword: data.get('authUrlPassword'),
          placeholder: data.get('authPlaceholder'),
          buttonLogin: data.get('authButtonLogin'),
          pleaseLogin: data.get('authPleaseLogin'),
          createAccount: data.get('authCreateAccount'),
          createAccountUrl: data.get('authCreateAccountUrl'),
          wrongPassword: data.get('authWrongPassword')
        },
        allowPreviousDays: data.get('allowPreviousDays').toString(),
        allowModalsAfterShutdown: data
          .get('allowModalsAfterShutdown')
          .toString(),
        modalBeforeDesign: data.get('modalBeforeDesign'),
        beforeLaunchModal: beforeLaunchModal,
        afterLaunchModal: afterLaunchModal,
        social: {
          headline: socialHeadline,
          facebook: data.get('facebook'),
          instagram: data.get('instagram'),
          linkedin: data.get('linkedin'),
          twitter: data.get('twitter'),
          youtube: data.get('youtube'),
          xing: data.get('xing'),
          vimeo: data.get('vimeo')
        },
        social2Update,
        social3Update,
        timezone: timezone.value ? timezone.value : timezone,
        hubspotPortalId: data.get('hubspotPortalId'),
        gaTrackingId: data.get('gaTrackingId'),
        gaTagManager: data.get('gaTagManager'),
        calendarUrl: data.get('calendarUrl'),
        shutdownDate: isValidDate(shutdownDate) && shutdownDate,
        startDate: isValidDate(startDate) && startDate,
        ogTitle: data.get('ogTitle'),
        ogDescription: data.get('ogDescription'),
        ogType: data.get('ogType'),
        ogUrl: data.get('ogUrl'),
        ogImage: ogImage || null,
        shareButton: shareButton || '',
        errorField: data.get('errorField'),
        languages: languages || null,
        languagePrimary: languagePrimary || Object.keys(languages)[0],
        displayLanguageSelector: displayLanguageSelector,
        enableInactiveColor: enableInactiveColor,
        inactiveColor: inactiveColor || null,
        useStockIcons: useStockIcons,
        socialMediaIcons: socialMediaIcons,
        popupColor: popupColor,
        disableFormSubmission: {
          disabled: disableFormSubmission.disabled,
          date: submissionCloseDate,
          text: submissionCloseMessage
        },
        showTimerTranslations,
        enableCaptcha,
        replaceEmptyTranslations,
        hasTouchedReplaceEmptyTranslations,
        enableCounterTranslations
      }
      if (showTimerTranslations) {
        const timerTextTranslationsValues = timerFields.reduce((acc, field) => {
          if(document.getElementById(field)) {
            acc[field] = document.getElementById(field).value || ''
          } else {
            acc[field] = ''
          }
          return acc
        }, {})
        udpateContent.timerTextTranslations = timerTextTranslationsValues
        udpateContent.timerRichTextTranslations = timerRichTextTranslations
      }
      if (enableCounterTranslations) {
        const hsCounterTextTranslationsValues = hsCounterTextFields.reduce((acc, field) => {
          if(document.getElementById(field)) {
            acc[field] = document.getElementById(field).value || ''
          } else {
            acc[field] = ''
          }
          return acc
        }, {})
        udpateContent.hsCounterTextTranslations = hsCounterTextTranslationsValues
        udpateContent.hsCounterTextRichTextTranslations = hsCounterTextRichTextTranslations
      }
      // udpateContent
      write(
        activeCompany,
        activeCalendar,
        calendarLangPrimary,
        calendarLang,
        'settings/grid',
        udpateContent
      )
        .then(() => {
          db.doc('companies/' + activeCompany + '/calendars/' + activeCalendar)
            .update({ changeToPublish: true })
            .then(res => { })
            .catch(error => {
              console.log(error)
            })
          notificationOpen('success')
        })
        .catch(error => {
          notificationOpen('error', error)
        })
    }
    db
      .doc(
        'companies/' +
        activeCompany +
        '/calendars/' +
        activeCalendar
      )
      .update({ name: data.get('internalCalendarName') })
  }

  const removeLanguage = async () => {
    setConfirmDeleteLanguage(true)
    const newLanguages = { ...languages }
    delete newLanguages[deleteLanguageModal]
    await db.doc(
      'companies/' +
      activeCompany +
      '/calendars/' +
      activeCalendar +
      '/translation/' +
      deleteLanguageModal +
      '/settings/grid'
    ).delete()

    // Update languages in DB settings
    await db.doc(
      'companies/' +
      activeCompany +
      '/calendars/' +
      activeCalendar +
      '/settings/grid'
    )
      .update({ languages: newLanguages })
      .then(res => { })
      .catch(error => {
        console.log(error)
      })
    setLanguages(newLanguages)
    setCalendarLanguages(newLanguages)

    dispatch({ type: 'CHANGE_CALENDAR_LANGS', value: newLanguages })
    setConfirmDeleteLanguage(false)
    setDeleteLanguageModal()
  }

  const notificationOpen = (type, errorMessage = '') => {
    if (type === 'success') {
      props.notificationOpen('tr', 'pe-7s-check', 'success', 'saved')
    } else if (type === 'error') {
      const message = 'not saved! Error: ' + errorMessage
      props.notificationOpen('tr', 'pe-7s-close-circle', 'error', message)
    }
  }

  const handleChangeAllowPreviousDays = event => {
    setAllowPreviousDays(event.target.value)
  }

  const handleChangeAllowModalsAfterShutdown = event => {
    setAllowModalsAfterShutdown(event.target.value)
  }

  const handleChangeAuth = event => {
    setAllowAuth(event.target.value)
  }
  const handleDisableFormSubmission = (field, value) => {
    setDisableFormSubmission((prev) => ({ ...prev, [field]: value }))
  }

  const handleChangeModalBeforeDesign = event => {
    setModalBeforeDesign(event.target.value)
  }

  const changeLanguage = lng => {
    i18next.changeLanguage(lng)
    setCurrentLanguage(lng)
  }

  const handleAddLanguage = () => {
    let newLanguages = { ...languages }
    let index

    if (!addLanguage) {
      // If not selected, select first lang index
      index = Object.keys(languagesData)[0]
    } else {
      index = addLanguage
    }

    if (!languages[index]) {
      newLanguages[index] = languagesData[index].name
      setLanguages(newLanguages)
      setCalendarLanguages(newLanguages)

      dispatch({ type: 'CHANGE_CALENDAR_LANGS', value: newLanguages })

      // Create tables for new language in DB
      db.doc(
        'companies/' +
        activeCompany +
        '/calendars/' +
        activeCalendar +
        '/translation/' +
        index +
        '/settings/grid'
      )
        .set({})
        .then(res => { })
        .catch(error => {
          console.log(error)
        })

      // Update languages in DB settings
      db.doc(
        'companies/' +
        activeCompany +
        '/calendars/' +
        activeCalendar +
        '/settings/grid'
      )
        .update({ languages: newLanguages })
        .then(res => { })
        .catch(error => {
          console.log(error)
        })
    }
  }

  const styleActiveLanguage = {
    borderBottom: '1px solid #87CB16',
    marginTop: '1px',
    marginLeft: '5px',
    cursor: 'pointer'
  }
  const styleLanguage = {
    marginLeft: '5px',
    cursor: 'pointer'
  }

  const handleChangeQuillBeforeLaunch = (value) => { setBeforeLaunchModal(value) }
  const handleChangeQuillAfterLaunch = (value) => { setAfterLaunchModal(value) }
  const handleChangeSocialHeadline = (value) => { setSocialHeadline(value) }

  const { t } = props

  return (
    <div className='content'>
      <Row
        className='show-grid'
        float='center'
        style={loading ? { display: 'block' } : { display: 'none' }}
      >
        <Col xs={12} xsOffset={6} valign='middle'>
          <Loading type='spin' color='green' />
        </Col>
      </Row>
      <Grid
        fluid
        style={!loading ? { visibility: 'visible' } : { visibility: 'hidden' }}
      >
        <form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className='setting-submit'>
              <Button bsStyle='info' pullRight fill type='submit'>
                {t('calSettings.updateSettings')}
              </Button>
              <div className='clearfix' />
            </Col>
            <Col md={12} style={{ maxHeight: '100%', overflow: 'scroll' }}>
              <Card
                title={t('calSettings.generalSetting')}
                content={
                  <div>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>
                            {t('calSettings.translation.UILanguage')}
                          </ControlLabel>
                          <div>
                            {' '}
                            <img
                              style={
                                currentLanguge === 'en'
                                  ? styleActiveLanguage
                                  : styleLanguage
                              }
                              onClick={() => changeLanguage('en')}
                              alt='English language'
                              src='data:image/png;base64,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'
                            />
                            <img
                              style={
                                currentLanguge === 'de'
                                  ? styleActiveLanguage
                                  : styleLanguage
                              }
                              onClick={() => changeLanguage('de')}
                              alt='German language'
                              src='data:image/png;base64,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'
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.calendarName')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.calendarName')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='calendarName'
                            id='calendarName'
                            placeholder={t('calSettings.calendarNameDesc')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.internalCalendarName')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.internalCalendarName')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='internalCalendarName'
                            id='internalCalendarName'
                            placeholder={t('calSettings.internalCalendarNameDesc')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.urlOfCalendar')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.calendarUrl')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='calendarUrl'
                            id='calendarUrl'
                            placeholder={t('calSettings.calendarUrlDesc')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.displayPreviousDays')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.displayPrevDays')}
                          </ControlLabel>
                          <FormControl
                            componentClass='select'
                            name='allowPreviousDays'
                            placeholder='select'
                            value={
                              allowPreviousDays && allowPreviousDays.toString()
                            }
                            onChange={handleChangeAllowPreviousDays}
                          >
                            <option value='true'>
                              {t('calSettings.displayPrevDaysYes')}
                            </option>
                            <option value='false'>
                              {t('calSettings.displayPrevDaysNo')}
                            </option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.timeZone')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.timeZone')}
                          </ControlLabel>
                          <TimezoneSelect
                            value={timezone}
                            onChange={setTimezone}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Link
                            to={
                              '/company/' +
                              activeCompany +
                              '/calendar/' +
                              activeCalendar +
                              '/duplicate-calendar'
                            }
                          >
                            <Button bsStyle='info' fill type='button'>
                              {t('calSettings.duplicateButton')}
                            </Button>
                          </Link>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />
              <Card
                title={t('calSettings.translation.languages')}
                content={
                  <div>
                    {languages && (
                      <Row>
                        <Col
                          md={6}
                          style={{
                            paddingBottom: '15px'
                          }}
                        >
                          {map(languages, (lang, index) => {
                            return (
                              <div
                                style={{
                                  padding: '5px 5px 5px 0'
                                }}
                              >
                                <img
                                  src={languagesData[index].icon}
                                  alt={languagesData[index].name}
                                />{' '}
                                {lang}{' '}
                                {index === languagePrimary ? (
                                  <>{t('calSettings.translation.primary')}</>
                                ) : (
                                  <DeleteOutlined onClick={() => setDeleteLanguageModal(index)} />
                                )}
                              </div>
                            )
                          })}
                        </Col>
                      </Row>
                    )}

                    <Row>
                      <Col md={2}>
                        <FormGroup>
                          <FormControl
                            componentClass='select'
                            name='addLanguage'
                            placeholder='select'
                            value={addLanguage}
                            onChange={e => {
                              setAddLanguage(e.target.value)
                            }}
                          >
                            {languagesData &&
                              map(languagesData, (lang, index) => {
                                return (
                                  <option value={index}>{lang.name}</option>
                                )
                              })}
                          </FormControl>
                        </FormGroup>
                      </Col>
                      <Col>
                        <Button
                          bsStyle='success'
                          fill
                          type='button'
                          onClick={handleAddLanguage}
                        >
                          {t('calSettings.translation.addLanguage')}
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4}>
                        <FormGroup>
                          <div className='checkbox'>
                            <FormControl
                              type='checkbox'
                              id='displayLanguageSelector'
                              name='displayLanguageSelector'
                              checked={displayLanguageSelector}
                              onChange={e =>
                                setDisplayLanguageSelector(e.target.checked)
                              }
                            />
                            <label htmlFor='displayLanguageSelector'>
                              {t('calSettings.translation.languageSelector')}
                            </label>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>

                    <div className='clearfix' />
                  </div>
                }
              />
              <Card
                title={t('calSettings.auth.title')}
                content={
                  <div>
                    <Row>
                      <Col md={6}>
                        <FormControl
                          componentClass='select'
                          name='allowAuth'
                          placeholder='select'
                          value={allowAuth && allowAuth.toString()}
                          onChange={handleChangeAuth}
                        >
                          <option value='true'>
                            {t('calSettings.auth.enable')}
                          </option>
                          <option value='false'>
                            {t('calSettings.auth.disable')}
                          </option>
                        </FormControl>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.password')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.password')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authPassword'
                            id='authPassword'
                            placeholder={t('calSettings.auth.passwordDesc')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.urlPassword')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.urlPassword')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authUrlPassword'
                            id='authUrlPassword'
                            placeholder={t('calSettings.auth.urlPasswordDesc')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.placeholder')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.placeholder')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authPlaceholder'
                            id='authPlaceholder'
                            placeholder={t('calSettings.auth.placeholderDesc')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.buttonLogin')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.buttonLogin')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authButtonLogin'
                            id='authButtonLogin'
                            placeholder={t('calSettings.auth.buttonLoginDesc')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.createAccount')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.createAccount')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authCreateAccount'
                            id='authCreateAccount'
                            placeholder={t(
                              'calSettings.auth.createAccountDesc'
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.createAccountUrl')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.createAccountUrl')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authCreateAccountUrl'
                            id='authCreateAccountUrl'
                            placeholder={t(
                              'calSettings.auth.createAccountUrlDesc'
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.pleaseLogin')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.pleaseLogin')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authPleaseLogin'
                            id='authPleaseLogin'
                            placeholder={t('calSettings.auth.pleaseLoginDesc')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.auth.wrongPassword')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.auth.wrongPassword')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='authWrongPassword'
                            id='authWrongPassword'
                            placeholder={t(
                              'calSettings.auth.wrongPasswordDesc'
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />
              <Card
                title={t('calSettings.socialNetworks')}
                content={
                  <div>
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.social_header')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.social_header')}
                              </ControlLabel>
                              <ReactQuill
                                value={socialHeadline}
                                modules={modules}
                                id='socialHeadline'
                                name='socialHeadline'
                                onChange={handleChangeSocialHeadline}
                                placeholder={t(
                                  'calSettings.pleaseProvideSocialHeader'
                                )}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <div className='checkbox'>
                                <FormControl
                                  type='checkbox'
                                  id='useStockIcons'
                                  name='useStockIcons'
                                  checked={useStockIcons}
                                  onChange={e =>
                                    setUseStockIcons(e.target.checked)
                                  }
                                />
                                <label htmlFor='useStockIcons'>
                                  {t('calSettings.useStockIcons')}
                                </label>
                              </div>
                              <div style={{
                                opacity: useStockIcons ? 1.0 : 0.5,
                                pointerEvents: useStockIcons ? 'all' : 'none'
                              }}>
                                <Row>
                                  <Col md={6}>
                                    <i
                                      className='pe-7s-help1 text-success'
                                      data-tip={t('settings.iconColor')}
                                      style={{
                                        position: 'relative',
                                        top: '1px',
                                        padding: '5px 5px 0 0',
                                        fontSize: '15px'
                                      }}
                                    />
                                    <ControlLabel>
                                      {t('calSettings.iconColor')}
                                    </ControlLabel>
                                    <ChromePicker
                                      styles={{
                                        'default': {
                                          picker: {
                                            width: '150px',
                                            marginBottom: '20px'
                                          }
                                        }
                                      }}
                                      disableAlpha
                                      color={socialMediaIcons.color || "#808080"}
                                      onChangeComplete={(color) => setSocialMediaIcons({ ...socialMediaIcons, color: color.hex })}
                                    />
                                  </Col>
                                  <Col md={6}>
                                    <i
                                      className='pe-7s-help1 text-success'
                                      data-tip={t('settings.iconSize')}
                                      style={{
                                        position: 'relative',
                                        top: '1px',
                                        padding: '5px 5px 0 0',
                                        fontSize: '15px'
                                      }}
                                    />
                                    <ControlLabel>
                                      {t('calSettings.iconSize')}
                                    </ControlLabel>
                                    <Radio.Group
                                      value={socialMediaIcons.size}
                                      size="small"
                                      style={{ marginTop: 5 }}
                                      onChange={(e) => { setSocialMediaIcons({ ...socialMediaIcons, size: e.target.value }) }}>
                                      <Radio.Button value="2x">Small</Radio.Button>
                                      <Radio.Button value="3x">Large</Radio.Button>
                                    </Radio.Group>
                                  </Col>
                                  <Col md={6}>
                                    <i
                                      className='pe-7s-help1 text-success'
                                      data-tip={t('settings.iconSize')}
                                      style={{
                                        position: 'relative',
                                        top: '1px',
                                        padding: '5px 5px 0 0',
                                        fontSize: '15px'
                                      }}
                                    />
                                    <ControlLabel>
                                      {t('calSettings.iconShape')}
                                    </ControlLabel>
                                    <Radio.Group
                                      value={socialMediaIcons.isRound}
                                      size="small"
                                      style={{ marginTop: 5 }}
                                      onChange={(e) => { setSocialMediaIcons({ ...socialMediaIcons, isRound: e.target.value }) }}>
                                      <Radio.Button value={true}>Round</Radio.Button>
                                      <Radio.Button value={false}>Rectangle</Radio.Button>
                                    </Radio.Group>
                                  </Col>
                                </Row>
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.facebook')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.facebookLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='facebook'
                                id='facebook'
                                placeholder={t(
                                  'calSettings.pleaseProvideFacebook'
                                )}
                              />

                              <FormControl
                                componentClass='select'
                                name='allowPreviousDays'
                                style={{
                                  maxWidth: '200px',
                                  marginTop: '10px'
                                }}
                                placeholder='select'
                                value={shareButton}
                                onChange={handleChangeShareButton}
                              >
                                <option value='yes'>
                                  {t('calSettings.display_share_button')}
                                </option>
                                <option value='no'>
                                  {t('calSettings.dont_display_share_button')}
                                </option>
                              </FormControl>
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.facebook_icon')}
                              </ControlLabel>
                            </FormGroup>
                            {
                              useStockIcons ?
                                <SocialMediaIcon icon={faFacebookF} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                                :
                                <UploadSingleImage
                                  {...props}
                                  activeCompany={activeCompany}
                                  activeCalendar={activeCalendar}
                                  fileName='facebook'
                                  pathToUload='social/'
                                  dbPath='settings/grid'
                                  dbField='social_icon_facebook'
                                  widthImage='50px'
                                  placeholderLabel={t('calSettings.upload')}
                                  maxMbToUpload='1'
                                />
                            }
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.twitter')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.twitterLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='twitter'
                                id='twitter'
                                placeholder={t(
                                  'calSettings.pleaseProvideTwitter'
                                )}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.twitter_icon')}
                              </ControlLabel>
                            </FormGroup>
                            {
                              useStockIcons ?
                                <SocialMediaIcon icon={faTwitter} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                                : <UploadSingleImage
                                  {...props}
                                  activeCompany={activeCompany}
                                  activeCalendar={activeCalendar}
                                  fileName='twitter'
                                  pathToUload='social/'
                                  dbPath='settings/grid'
                                  dbField='social_icon_twitter'
                                  widthImage='50px'
                                  placeholderLabel={t('calSettings.upload')}
                                  maxMbToUpload='1'
                                />
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.instagram')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.instagramLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='instagram'
                                id='instagram'
                                placeholder={t('calSettings.instagramLink')}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.instagram_icon')}
                              </ControlLabel>

                            </FormGroup>
                            {useStockIcons ?
                              <SocialMediaIcon icon={faInstagram} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                              : <UploadSingleImage
                                {...props}
                                activeCompany={activeCompany}
                                activeCalendar={activeCalendar}
                                fileName='instagram'
                                pathToUload='social/'
                                dbPath='settings/grid'
                                dbField='social_icon_instagram'
                                widthImage='50px'
                                placeholderLabel={t('calSettings.upload')}
                                maxMbToUpload='1'
                              />}
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.linkedIn')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.linkedinLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='linkedin'
                                id='linkedin'
                                placeholder={t(
                                  'calSettings.pleaseProvideLinkedin'
                                )}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.linkedin_icon')}
                              </ControlLabel>

                            </FormGroup>
                            {useStockIcons ?
                              <SocialMediaIcon icon={faLinkedinIn} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                              : <UploadSingleImage
                                {...props}
                                activeCompany={activeCompany}
                                activeCalendar={activeCalendar}
                                fileName='linkedin'
                                pathToUload='social/'
                                dbPath='settings/grid'
                                dbField='social_icon_linkedin'
                                widthImage='50px'
                                placeholderLabel={t('calSettings.upload')}
                                maxMbToUpload='1'
                              />
                            }
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.linkedIn')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.youtubeLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='youtube'
                                id='youtube'
                                placeholder={t(
                                  'calSettings.pleaseProvideYoutube'
                                )}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.youtube_icon')}
                              </ControlLabel>
                            </FormGroup>
                            {useStockIcons ?
                              <SocialMediaIcon icon={faYoutube} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                              : <UploadSingleImage
                                {...props}
                                activeCompany={activeCompany}
                                activeCalendar={activeCalendar}
                                fileName='youtube'
                                pathToUload='social/'
                                dbPath='settings/grid'
                                dbField='social_icon_youtube'
                                widthImage='50px'
                                placeholderLabel={t('calSettings.upload')}
                                maxMbToUpload='1'
                              />}
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.linkedIn')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.xingLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='xing'
                                id='xing'
                                placeholder={t('calSettings.pleaseProvideXing')}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.xing_icon')}
                              </ControlLabel>
                            </FormGroup>
                            {useStockIcons ?
                              <SocialMediaIcon icon={faXing} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                              : <UploadSingleImage
                                {...props}
                                activeCompany={activeCompany}
                                activeCalendar={activeCalendar}
                                fileName='xing'
                                pathToUload='social/'
                                dbPath='settings/grid'
                                dbField='social_icon_xing'
                                widthImage='50px'
                                placeholderLabel={t('calSettings.upload')}
                                maxMbToUpload='1'
                              />
                            }
                          </Col>
                        </Row>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.linkedIn')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.vimeoLink')}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name='vimeo'
                                id='vimeo'
                                placeholder={t('calSettings.pleaseProvideVimeo')}
                              />
                            </FormGroup>
                          </Col>
                          <Col md={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('style.backgroundImage')}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.vimeo_icon')}
                              </ControlLabel>
                            </FormGroup>
                            {useStockIcons ?
                              <SocialMediaIcon icon={faVimeoV} color={socialMediaIcons.color} size={socialMediaIcons.size} isRound={socialMediaIcons.isRound} />
                              : <UploadSingleImage
                                {...props}
                                activeCompany={activeCompany}
                                activeCalendar={activeCalendar}
                                fileName='vimeo'
                                pathToUload='social/'
                                dbPath='settings/grid'
                                dbField='social_icon_vimeo'
                                widthImage='50px'
                                placeholderLabel={t('calSettings.upload')}
                                maxMbToUpload='1'
                              />
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />
              {social2 && (
                <Card
                  title={t('calSettings.socialNetworks') + ' 2'}
                  content={
                    <div>
                      <Row>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.social_header')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.social_header')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='socialHeadline2'
                                  id='socialHeadline2'
                                  placeholder={t(
                                    'calSettings.pleaseProvideSocialHeader'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.facebook')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.facebookLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='facebook2'
                                  id='facebook2'
                                  placeholder={t(
                                    'calSettings.pleaseProvideFacebook'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.twitter')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.twitterLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='twitter2'
                                  id='twitter2'
                                  placeholder={t(
                                    'calSettings.pleaseProvideTwitter'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.instagram')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.instagramLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='instagram2'
                                  id='instagram2'
                                  placeholder={t('calSettings.instagramLink')}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.linkedIn')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.linkedinLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='linkedin2'
                                  id='linkedin2'
                                  placeholder={t(
                                    'calSettings.pleaseProvideLinkedin'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.linkedIn')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.youtubeLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='youtube2'
                                  id='youtube2'
                                  placeholder={t(
                                    'calSettings.pleaseProvideYoutube'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.linkedIn')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.xingLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='xing2'
                                  id='xing2'
                                  placeholder={t(
                                    'calSettings.pleaseProvideXing'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className='clearfix' />
                    </div>
                  }
                />
              )}
              {social3 && (
                <Card
                  title={t('calSettings.socialNetworks') + ' 3'}
                  content={
                    <div>
                      <Row>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.social_header')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.social_header')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='socialHeadline3'
                                  id='socialHeadline3'
                                  placeholder={t(
                                    'calSettings.pleaseProvideSocialHeader'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.facebook')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.facebookLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='facebook3'
                                  id='facebook3'
                                  placeholder={t(
                                    'calSettings.pleaseProvideFacebook'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.twitter')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.twitterLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='twitter3'
                                  id='twitter3'
                                  placeholder={t(
                                    'calSettings.pleaseProvideTwitter'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.instagram')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.instagramLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='instagram3'
                                  id='instagram3'
                                  placeholder={t('calSettings.instagramLink')}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.linkedIn')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.linkedinLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='linkedin3'
                                  id='linkedin3'
                                  placeholder={t(
                                    'calSettings.pleaseProvideLinkedin'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.linkedIn')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.youtubeLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='youtube3'
                                  id='youtube3'
                                  placeholder={t(
                                    'calSettings.pleaseProvideYoutube'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                        <Col md={12}>
                          <Row>
                            <Col md={4}>
                              <FormGroup>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('settings.linkedIn')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 5px 0 0',
                                    fontSize: '15px'
                                  }}
                                />
                                <ControlLabel>
                                  {t('calSettings.xingLink')}
                                </ControlLabel>
                                <FormControl
                                  type='text'
                                  name='xing3'
                                  id='xing3'
                                  placeholder={t(
                                    'calSettings.pleaseProvideXing'
                                  )}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <div className='clearfix' />
                    </div>
                  }
                />
              )}
              <Card
                title={t('calSettings.calendarBlocking')}
                content={
                  <div>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.startDate')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.launchDate')}
                          </ControlLabel>
                          <FormControl
                            type='date'
                            name='startDate'
                            id='startDate'
                            placeholder=''
                            min={new Date(2018, 0, 2, 0, 0, 0, 0).toISOString().split("T")[0]}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.shutdownDate')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.shutdownDate')}
                          </ControlLabel>
                          <FormControl
                            type='date'
                            name='shutdownDate'
                            id='shutdownDate'
                            placeholder=''
                            min={new Date(2018, 0, 2, 0, 0, 0, 0).toISOString().split("T")[0]}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <i
                          className='pe-7s-help1 text-success'
                          data-tip={t('settings.popupColor')}
                          style={{
                            position: 'relative',
                            top: '1px',
                            padding: '5px 5px 0 0',
                            fontSize: '15px'
                          }}
                        />
                        <ControlLabel>
                          {t('calSettings.popupColor')}
                        </ControlLabel>
                        <ChromePicker
                          styles={{
                            'default': {
                              picker: {
                                marginBottom: '20px'
                              }
                            }
                          }}
                          disableAlpha
                          color={popupColor}
                          onChangeComplete={(color) => setPopupColor(color.hex)}
                        />
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.allowModalsAfterShutdown')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.displayModalsAfter')}
                          </ControlLabel>
                          <FormControl
                            componentClass='select'
                            name='allowModalsAfterShutdown'
                            placeholder='select'
                            value={
                              allowModalsAfterShutdown &&
                              allowModalsAfterShutdown.toString()
                            }
                            onChange={handleChangeAllowModalsAfterShutdown}
                          >
                            <option value='true'>
                              {t('calSettings.displayModalsAfterYes')}
                            </option>
                            <option value='false'>
                              {t('calSettings.displayModalsAfterNo')}
                            </option>
                          </FormControl>
                        </FormGroup>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('calSettings.disabledFormAfterSubmissionClose')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.disabledFormSubmission')}
                          </ControlLabel>
                          <div>
                            <Switch checked={disableFormSubmission.disabled} onChange={(value) => handleDisableFormSubmission("disabled", value)} />
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('calSettings.submissionCloseDate')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.submissionCloseDate')}
                          </ControlLabel>
                          <FormControl
                            type='date'
                            name='submissionCloseDate'
                            id='submissionCloseDate'
                            placeholder=''
                            disabled={!disableFormSubmission.disabled}
                            min={new Date().toISOString().split("T")[0]}
                          />
                        </FormGroup>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('calSettings.submissionCloseMessage')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.submissionCloseMessage')}
                          </ControlLabel>
                          <ReactQuill
                            value={disableFormSubmission.text}
                            modules={modules}
                            id='submissionCloseMessage'
                            name='submissionCloseMessage'
                            onChange={(value) => handleDisableFormSubmission("text", value)}
                            readOnly={!disableFormSubmission.disabled}
                            className='react-quill-custom'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.allowModalsAfterShutdown')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.designOfBeforeLaunch')}
                          </ControlLabel>
                          <FormControl
                            componentClass='select'
                            name='modalBeforeDesign'
                            placeholder='select'
                            value={modalBeforeDesign}
                            onChange={handleChangeModalBeforeDesign}
                          >
                            <option value='default'>
                              {t('calSettings.defaultDesign')}
                            </option>
                            <option value='loadingRabbit'>
                              {t('calSettings.iconWithRabbit')}
                            </option>
                            <option value='loadingTreeCountdown'>
                              {t('calSettings.iconWithTreeCountdown')}
                            </option>
                            <option value='loadingTree'>
                              {t('calSettings.iconWithTree')}
                            </option>
                            <option value='loadingAvatar'>
                              {t('calSettings.iconWithAvatar')}
                            </option>
                          </FormControl>
                        </FormGroup>
                      </Col>
                      <Col md={6} />
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.beforeLaunchModal')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.beforeLaunchInfoModal')}
                          </ControlLabel>
                          <ReactQuill
                            value={beforeLaunchModal}
                            modules={modules}
                            id='beforeLaunchModal'
                            name='beforeLaunchModal'
                            onChange={handleChangeQuillBeforeLaunch}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.afterLaunchModal')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.afterShutdownModal')}
                          </ControlLabel>
                          <ReactQuill
                            value={afterLaunchModal}
                            modules={modules}
                            id='afterLaunchModal'
                            name='afterLaunchModal'
                            onChange={handleChangeQuillAfterLaunch}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={4} lg={6}>
                        <FormGroup>
                          <div className='checkbox'>
                            <FormControl
                              type='checkbox'
                              id='enableInactiveColor'
                              name='enableInactiveColor'
                              checked={enableInactiveColor}
                              onChange={e =>
                                setEnableInactiveColor(e.target.checked)
                              }
                            />
                            <label htmlFor='enableInactiveColor'>
                              {t('calSettings.enableInactiveColor')}
                            </label>
                          </div>
                          <div style={{
                            opacity: enableInactiveColor ? 1.0 : 0.5,
                            pointerEvents: enableInactiveColor ? 'all' : 'none'
                          }}>
                            <ChromePicker
                              disableAlpha
                              color={inactiveColor}
                              onChangeComplete={(color) => setInactiveColor(color.hex)}
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />
              <Card
                title={t('calSettings.apis')}
                content={
                  <div>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.hubSpotApi')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.hubspot')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='hubspotPortalId'
                            id='hubspotPortalId'
                            placeholder={t('calSettings.toListUsersActivity')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.googleAnalytics')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.googleAnalytics')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='gaTrackingId'
                            id='gaTrackingId'
                            placeholder={t(
                              'calSettings.pleaseProvideGoogleAnalytics'
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.googleTagManager')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.googleTagManager')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='gaTagManager'
                            id='gaTagManager'
                            placeholder={t(
                              'calSettings.pleaseProvideGoogleTagManager'
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />
              <Card
                title={t('calSettings.formSettings.title')}
                content={
                  <div>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>
                            <div className='checkbox'>
                              <input
                                type='checkbox'
                                id='enableCaptcha'
                                name='enableCaptcha'
                                checked={enableCaptcha}
                                onChange={handleChangeEnableCaptcha}
                              />
                              <label htmlFor='enableCaptcha'>
                                {t('calSettings.formSettings.enableCaptcha')}
                              </label>
                            </div>
                          </ControlLabel>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('calSettings.formSettings.enableCaptchaDesc')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 0 0 5px',
                              fontSize: '15px'
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />

              <Card
                title={t('calSettings.translation.title')}
                content={
                  <div>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.errorField')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.translation.error_field')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='errorField'
                            id='errorField'
                            placeholder={t(
                              'calSettings.translation.error_placeholder'
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {type === 'memory-game' && <>
                      <h4>{t('calSettings.translation.timerTitle')}</h4>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <ControlLabel>
                              <div className='checkbox'>
                                <input
                                  type='checkbox'
                                  id='showTimerTranslations'
                                  name='showTimerTranslations'
                                  checked={showTimerTranslations}
                                  onChange={handleChangeShowTimerTranslations}
                                />
                                <label htmlFor='showTimerTranslations'>
                                  {t('calSettings.translation.showTimerTranslations')}
                                </label>
                              </div>
                            </ControlLabel>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('calSettings.translation.showTimerTranslations')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 0 0 5px',
                                fontSize: '15px'
                              }}
                            />
                          </FormGroup>
                        </Col>
                        {
                          showTimerTranslations && (
                            <Col md={12}>
                              <FormGroup>
                                <ControlLabel>
                                  <div className='checkbox'>
                                    <input
                                      type='checkbox'
                                      id='replaceEmptyTranslations'
                                      name='replaceEmptyTranslations'
                                      checked={replaceEmptyTranslations}
                                      onChange={e => {
                                        setReplaceEmptyTranslations(e.target.checked)
                                        if (!hasTouchedReplaceEmptyTranslations) {
                                          setHasTouchedReplaceEmptyTranslations(true)
                                        }
                                      }}
                                    />
                                    <label htmlFor='replaceEmptyTranslations'>
                                      {t('calSettings.translation.replaceEmptyTranslations')}
                                    </label>
                                  </div>
                                </ControlLabel>
                                <i
                                  className='pe-7s-help1 text-success'
                                  data-tip={t('calSettings.translation.replaceEmptyTranslations_tooltip')}
                                  style={{
                                    position: 'relative',
                                    top: '1px',
                                    padding: '5px 0 0 5px',
                                    fontSize: '15px'
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          )
                        }
                        {showTimerTranslations && timerFields.map(field => (
                          <Col md={6} lg={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.' + field)}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.translation.' + field)}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name={field}
                                id={field}
                                placeholder={t(
                                  'calSettings.translation.' + field + '_placeholder'
                                )}
                              />
                            </FormGroup>
                          </Col>
                        ))}
                      </Row>
                      <Row>
                        {showTimerTranslations && timerRichTextFields.map(field => (
                          <Col md={12} lg={6}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.' + field)}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.translation.' + field)}
                              </ControlLabel>
                              <ReactQuill
                                value={timerRichTextTranslations[field]}
                                modules={modules}
                                id={field}
                                name={field}
                                onChange={(value) => handleChangeTimerRichTextTranslations(field, value)}
                                className='react-quill-custom'
                              />
                            </FormGroup>
                          </Col>
                        ))}
                      </Row>
                    </>}
                    {type === 'hide-and-seek' && <>
                      <h4>{t('calSettings.translation.hideAndSeek.counterTitle')}</h4>
                      <Row>
                        <Col md={12}>
                          <FormGroup>
                            <ControlLabel>
                              <div className='checkbox'>
                                <input
                                  type='checkbox'
                                  id='enableCounterTranslations'
                                  name='enableCounterTranslations'
                                  checked={enableCounterTranslations}
                                  onChange={handleChangeEnableCounterTranslations}
                                />
                                <label htmlFor='enableCounterTranslations'>
                                  {t('calSettings.translation.hideAndSeek.enableCounterTranslations')}
                                </label>
                              </div>
                            </ControlLabel>
                            <i
                              className='pe-7s-help1 text-success'
                              data-tip={t('calSettings.translation.hideAndSeek.enableCounterTranslations')}
                              style={{
                                position: 'relative',
                                top: '1px',
                                padding: '5px 0 0 5px',
                                fontSize: '15px'
                              }}
                            />
                          </FormGroup>
                        </Col>
                        {enableCounterTranslations && hsCounterTextFields.map(field => (
                          <Col md={6} lg={4}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.' + field)}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.translation.hideAndSeek.' + field)}
                              </ControlLabel>
                              <FormControl
                                type='text'
                                name={field}
                                id={field}
                                placeholder={t(
                                  'calSettings.translation.hideAndSeek.' + field + '_placeholder'
                                )}
                              />
                            </FormGroup>
                          </Col>
                        ))}
                      </Row>
                      <Row>
                        {enableCounterTranslations && hsCounterTextRichTextFields.map(field => (
                          <Col md={12} lg={6}>
                            <FormGroup>
                              <i
                                className='pe-7s-help1 text-success'
                                data-tip={t('settings.' + field)}
                                style={{
                                  position: 'relative',
                                  top: '1px',
                                  padding: '5px 5px 0 0',
                                  fontSize: '15px'
                                }}
                              />
                              <ControlLabel>
                                {t('calSettings.translation.hideAndSeek.' + field)}
                              </ControlLabel>
                              <ReactQuill
                                value={hsCounterTextRichTextTranslations[field]}
                                modules={modules}
                                id={field}
                                name={field}
                                onChange={(value) => handleChangeHsCounterTextRichTextTranslations(field, value)}
                                className='react-quill-custom'
                              />
                            </FormGroup>
                          </Col>
                        ))}
                      </Row>
                    </>}
                    
                  </div>
                }
              />
              <Card
                title={t('calSettings.ogTags.ogTags')}
                content={
                  <div>
                    {'To make OG tag changes available, calendar must be re-deployed. ' + t('calImplementation.futherAssistance')}
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.ogTitle')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.ogTags.title')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='ogTitle'
                            id='ogTitle'
                            placeholder={t('calSettings.ogTags.title')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.ogDescription')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.ogTags.description')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='ogDescription'
                            id='ogDescription'
                            placeholder={t('calSettings.ogTags.description')}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.ogType')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.ogTags.type')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='ogType'
                            id='ogType'
                            placeholder={t('calSettings.ogTags.type')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.ogUrl')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.ogTags.url')}
                          </ControlLabel>
                          <FormControl
                            type='text'
                            name='ogUrl'
                            id='ogUrl'
                            placeholder={t('calSettings.ogTags.url')}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <i
                            className='pe-7s-help1 text-success'
                            data-tip={t('settings.ogImage')}
                            style={{
                              position: 'relative',
                              top: '1px',
                              padding: '5px 5px 0 0',
                              fontSize: '15px'
                            }}
                          />
                          <ControlLabel>
                            {t('calSettings.ogTags.image')}
                          </ControlLabel>
                          <FileSelector
                            type='image'
                            activeCompany={activeCompany}
                            activeCalendar={activeCalendar}
                            url={ogImage}
                            onSelect={(file) => setOgImage(file.url)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='clearfix' />
                  </div>
                }
              />
              <Button bsStyle='info' pullRight fill type='submit'>
                {t('calSettings.updateSettings')}
              </Button>
              <Modal
                title={t('calSettings.deleteLanguageModal.title')}
                open={deleteLanguageModal}
                onOk={removeLanguage}
                confirmLoading={confirmDeleteLanguage}
                onCancel={() => setDeleteLanguageModal()}
                centered
              >
                <p>{t('calSettings.deleteLanguageModal.description')}</p>
              </Modal>
              <div className='clearfix' />
            </Col>
          </Row>
        </form>
      </Grid>
      <ReactTooltip place='top' type='dark' effect='solid' />
    </div>
  )
}

export default translate('translations')(CalSetttings)
